'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FallbackExportComponent = function FallbackExportComponent(_ref) {
    var element = _ref.element;
    return _react2.default.createElement(
        'p',
        null,
        'Export not supported for element type: ',
        element.elementType
    );
};

FallbackExportComponent.propTypes = {
    element: _propTypes2.default.object
};

exports.default = FallbackExportComponent;


//////////////////
// WEBPACK FOOTER
// ./src/common/elements/ElementExportFallback.js
// module id = 2264
// module chunks = 0